import { advancedColors } from '../../theme'

export const headerCellSx = {
  border: `1px solid ${advancedColors.line}`,
  backgroundColor: advancedColors.cardBg,
  p: 0,
}

export const dataCellSx = {
  border: `1px solid ${advancedColors.line}`,
  p: 0,
}

export const cellInputSx = { px: 1, py: 0.5 }
